

<div *ngIf="bienvenida" class="bienvenida">
  <p class="message">Bienvenido al sistema "{{ nombreCompleto }}"</p>
  <p class="log">Ultimo inicio de sesión</p>
  <p class="date">{{ultimaconexion}}</p>
  <i class="fa fa-times cerrarBienvenida" aria-hidden="true" (click)="cerrar()"></i>
</div>

<div class="container-main">
  <mat-tab-group animationDuration="0ms">
    <mat-tab *ngIf="widgetCasos">
      <ng-template mat-tab-label>
        <i class="fa fa-chart-bar"></i>
        <span>Casos analizados</span>
      </ng-template>

      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <h3 class="title-chart">Casos Analizados</h3>
            <div class="d-flex no-block justify-content-between">
              <ngx-charts-bar-vertical
                [view]="view"
                [scheme]="colorScheme"
                [results]="singlegetCasosAnalizados"
                [gradient]="gradient"
                [xAxis]="showXAxis"
                [yAxis]="showYAxis"
                [legend]="showLegend"
                [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel"
                [xAxisLabel]="xAxisLabelCasosAnalizados"
                [yAxisLabel]="yAxisLabelCasosAnalizados"
                (select)="onSelect($event)">
              </ngx-charts-bar-vertical>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab *ngIf="widgetCanales">
      <ng-template mat-tab-label>
        <i class="fa fa-chart-bar"></i>
        <span>Mis canales</span>
      </ng-template>

      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <h3 class="title-chart">Mis Canales</h3>
            <div class="d-flex no-block justify-content-between">
              <ngx-charts-bar-vertical-2d
                [view]="view"
                [scheme]="colorScheme"
                [results]="multiMisCanales"
                [gradient]="gradient"
                [xAxis]="showXAxis"
                [yAxis]="showYAxis"
                [legend]="showLegend"
                [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel"
                [xAxisLabel]="xAxisLabelMisCanales"
                [yAxisLabel]="yAxisLabelMisCanales"
                (select)="onSelect($event)"
                (activate)="onActivate($event)"
                (deactivate)="onDeactivate($event)">
              </ngx-charts-bar-vertical-2d>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab *ngIf="widgetMontos">
      <ng-template mat-tab-label>
        <i class="fa fa-chart-bar"></i>
        <span>Mis montos</span>
      </ng-template>

      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card">
          <div #containerRefUsers class="card-body">
            <h3 class="title-chart">Mis Montos</h3>
            <div class="d-flex no-block justify-content-between">
              <ngx-charts-bar-vertical
                [view]="view"
                [scheme]="colorScheme"
                [results]="singleMisMontos"
                [gradient]="gradient"
                [xAxis]="showXAxis"
                [yAxis]="showYAxis"
                [legend]="showLegend"
                [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel"
                [xAxisLabel]="xAxisLabelMisMontos"
                [yAxisLabel]="yAxisLabelMisMontos"
                (select)="onSelect($event)">
              </ngx-charts-bar-vertical>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab *ngIf="widgetCasosAll">
      <ng-template mat-tab-label>
        <i class="fa fa-chart-bar"></i>
        <span>Casos analista</span>
      </ng-template>

      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card">
          <div #containerRefConexiones class="card-body">
            <h3 class="title-chart">Casos Analista</h3>
            <div class="d-flex no-block justify-content-between">
              <ngx-charts-bar-vertical-2d
              [view]="view"
              [scheme]="colorScheme"
              [results]="multiCasosAnalista"
              [gradient]="gradient"
              [xAxis]="showXAxis"
              [yAxis]="showYAxis"
              [legend]="showLegend"
              [showXAxisLabel]="showXAxisLabel"
              [showYAxisLabel]="showYAxisLabel"
              [xAxisLabel]="xAxisLabelCasosAnalista"
              [yAxisLabel]="yAxisLabelCasosAnalista"
              (select)="onSelect($event)"
              (activate)="onActivate($event)"
              (deactivate)="onDeactivate($event)">
            </ngx-charts-bar-vertical-2d>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab *ngIf="widgetCanalesAll">
      <ng-template mat-tab-label>
        <i class="fa fa-chart-bar"></i>
        <span>Canales analista</span>
      </ng-template>

      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card">
          <div #containerRefConexiones class="card-body">
            <h3 class="title-chart">Canales Analista</h3>
            <div class="d-flex no-block justify-content-between">
              <ngx-charts-bar-vertical-2d
              [view]="view"
              [scheme]="colorScheme"
              [results]="multiCanalesAnalista"
              [gradient]="gradient"
              [xAxis]="showXAxis"
              [yAxis]="showYAxis"
              [legend]="showLegend"
              [showXAxisLabel]="showXAxisLabel"
              [showYAxisLabel]="showYAxisLabel"
              [xAxisLabel]="xAxisLabelCanalesAnalista"
              [yAxisLabel]="yAxisLabelCanalesAnalista"
              (select)="onSelect($event)"
              (activate)="onActivate($event)"
              (deactivate)="onDeactivate($event)">
            </ngx-charts-bar-vertical-2d>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <!-- <mat-tab *ngIf="widgetNotificaciones">
      <ng-template mat-tab-label>
        <i class="fa fa-chart-bar"></i>
        <span>Notificaciones</span>
      </ng-template>

      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card">
          <div #containerRefConexiones class="card-body">
            <h3 class="title-chart">Notificaciones mas recientes</h3>
            <div class="d-flex no-block justify-content-between">
              <div style="margin-left:auto;margin-right:auto; width:500px;">
	              <div class="notificaciones_content">
	              	<ul>
	              		<li *ngFor="let notificacion of notificaciones" (click)="openCasoNot(notificacion)">
	              			<ng-container *ngIf="notificacion.estado == 'activo'">
	              				<h4>{{ notificacion.msj.substring(0,17) }}</h4>
	              				<p>{{ notificacion.msj.substring(17,notificacion.msj.length) }} {{ notificacion.comentario ? '- '+notificacion.comentario : '' }}</p>
	              				<p>{{ timeAgo(notificacion.date, 'es') }}</p>
	              			</ng-container>
	              		</li>
	              	</ul>
	              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab> -->
  </mat-tab-group>
</div>
